import styled from "styled-components";

export const StyledCareerManagerDetail = styled.div`
  padding: 24px;
  height: calc(100% - 48px);
  overflow-y: auto;

  & .personal-data-row {
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 20px;
    white-space: nowrap;
  }

  & .search-container {
    width: 250px;
  }

  & .table-header {
    margin-bottom: 20px;
  }
`;
